import {TableCell, TableRow, Typography} from "@mui/material";
import {formatDateToMonthDay} from "../../../../../utils/timeUtils";

export const QueryResultsRow = ({row, queryHasAtClause}: { row: any, queryHasAtClause: boolean }) => {

    if(queryHasAtClause) return (
        <TableRow
            sx={{
                '& > *': {paddingTop: '9px !important', paddingBottom: '9px !important'},
                '&:hover': {
                    backgroundColor: 'lightgrey',
                    cursor: 'pointer',
                },
            }}
            key={row.id}
        >
            {Object.values(row?.dynamicFields?.[0] || []).map((value: string | number | any) => {
                return (
                    <TableCell component="th" scope="row" align="left">
                        {Number(value) ? value.toFixed(2) : value}
                    </TableCell>
                )
            })}

        </TableRow>
    )

    return (
        <TableRow
            sx={{
                '& > *': {
                    paddingTop: '9px !important',
                    paddingBottom: '9px !important'
                },
            }}
            key={row.id}
        >
            <TableCell component="th" scope="row" align="left">
                {formatDateToMonthDay(row?.date || '', true)}
            </TableCell>
            <TableCell component="th" scope="row" align="left">
                {row?.school || row?.team} {row.line > 0 ? '+' + row.line : row.line}
                <Typography
                    component='span'
                    variant='caption'
                    style={{fontWeight: '600', color: 'grey'}}>
                    {row.rank ? ` (Rank: ${row.rank})` : ''}
                </Typography>
            </TableCell>
            <TableCell
                align="left"
                sx={{
                    fontWeight: '600',
                    color: (theme) =>
                        row.atsMargin > 0 ? theme.palette.success.main : theme.palette.error.main,
                }}
            >
                {row.atsMargin}
            </TableCell>
            <TableCell align="left">
                {row?.oSchool || row?.['oTeam']} {row.oLine > 0 ? '+' + row.oLine : row.oLine}
                <Typography component='span' variant='caption' style={{fontWeight: '600', color: 'grey'}}>
                    {row.oRank ? ` (Rk: ${row.oRank})` : ''}
                </Typography>
            </TableCell>
            <TableCell align="left">{row.total}</TableCell>
            <TableCell
                align="left"
                sx={{
                    fontWeight: '600',
                    color: (theme) =>
                        row.ouMargin > 0 ? theme.palette.success.main : theme.palette.error.main,
                }}
            >
                {row.ouMargin}
            </TableCell>
            <TableCell align="left">
                <Typography
                    component="span"
                    variant="body2"
                    sx={{
                        fontWeight: '600',
                        color: (theme) =>
                            row.points > row.oPoints ? theme.palette.success.main : theme.palette.error.main,
                    }}
                >
                    {row.points ?? ''}
                </Typography>
                {row.oPoints ? ' - ' + row.oPoints : ''}
            </TableCell>
        </TableRow>
    )
}